<template>
  <div class="sky-hc-index">
    <div class="sky-hc-index__banner">
      <div
        class="sky-hc-index__banner-img"
        :style="{ backgroundImage: 'url(' + bannerImg + ')' }"
        @click="handeClickBanner"
      ></div>
      <search-box class="sky-hc-index__search-box" @search="handleSearch"> </search-box>
    </div>
    <div class="sky-hc-index__content">
      <div class="sky-hc-index__quick-box">
        <div class="sky-hc-index__quick-item sky-hc-index__quick-item-tit">{{ $t('help.newMemberGuide') }}</div>
        <div class="sky-hc-index__quick-item" @click="handleGoToInnerPage(1)">
          <div class="sky-hc-index__quick-con">
            <div class="sky-hc-index__quick-tit">{{ $t('help.quicklyUnderstand') }}</div>
            <div class="sky-hc-index__quick-txt">{{ $t('help.productProfile') }}</div>
          </div>
          <img
            src="@/assets/images/help/icon_profile.png"
            srcset="@/assets/images/help/icon_profile@2x.png"
            class="sky-hc-index__quick-icon sky-hc-index__quick-icon--product"
          />
        </div>
        <div class="sky-hc-index__quick-item" @click="handleGoToInnerPage(2)">
          <div class="sky-hc-index__quick-con">
            <div class="sky-hc-index__quick-tit">{{ $t('help.quickLearning') }}</div>
            <div class="sky-hc-index__quick-txt">{{ $t('help.operationGuide') }}</div>
          </div>
          <img
            src="@/assets/images/help/icon_guide.png"
            srcset="@/assets/images/help/icon_guide@2x.png"
            class="sky-hc-index__quick-icon sky-hc-index__quick-icon--guide"
          />
        </div>
        <div class="sky-hc-index__quick-item" @click="handleGoToInnerPage(3)">
          <div class="sky-hc-index__quick-con">
            <div class="sky-hc-index__quick-tit">{{ $t('help.userDeriction') }}</div>
            <div class="sky-hc-index__quick-txt">{{ $t('help.basicOperation') }}</div>
          </div>
          <img
            src="@/assets/images/help/icon_instruction.png"
            srcset="@/assets/images/help/icon_instruction@2x.png"
            class="sky-hc-index__quick-icon sky-hc-index__quick-icon--instructions"
          />
        </div>
        <div class="sky-hc-index__quick-item" @click="handleGotoExperience">
          <div class="sky-hc-index__quick-con">
            <div class="sky-hc-index__quick-tit">{{ $t('help.experience') }}</div>
            <div class="sky-hc-index__quick-txt">{{ $t('help.productExperience') }}</div>
          </div>
          <img
            src="@/assets/images/help/icon_experience.png"
            srcset="@/assets/images/help/icon_experience@2x.png"
            class="sky-hc-index__quick-icon sky-hc-index__quick-icon--experience"
          />
        </div>
      </div>
      <div class="sky-hc-index__article-box">
        <help-card class="sky-hc-index__article-item" :data="module1List" :category="category1"></help-card>
        <help-card class="sky-hc-index__article-item" :data="module2List" :category="category2"></help-card>
        <help-card class="sky-hc-index__article-item" :data="module3List" :category="category3"></help-card>
      </div>
      <h2 class="sky-hc-index__img-article-tit" @click="handleGoToInnerPage(false)">
        {{ category4 ? category4.categoryName : '' }}
      </h2>
      <div class="sky-hc-index__img-article-box">
        <help-img-card
          class="sky-hc-index__img-article-item"
          v-for="item in module4List"
          :key="item.id"
          :data="item"
          :category="category4"
        ></help-img-card>
        <no-data v-if="!module4List.length" class="sky-hc-index__img-article-no-data" />
      </div>
    </div>
    <dialog-experience-account :isVisible="isVisible" @close="handleCloseExperience" />
    <Footer></Footer>
  </div>
</template>
<script>
import { Input, Button } from 'element-ui'

import { mapGetters } from 'vuex'

import DialogExperienceAccount from '../components/DialogExperienceAccount'

import Footer from '../components/footer'
import helpCard from '../components/helpCard'
import HelpImgCard from '../components/helpImgCard'
import NoData from '../components/noData'
import SearchBox from '../components/searchBox'

import { getHomePageSetting, getHelpArticleList, getIndexCategory } from '@/api/help'
import { CATEGORY_TYPE } from '@/utils/enum'
export default {
  name: 'Index',
  components: {
    [Input.name]: Input,
    [Button.name]: Button,
    helpCard,
    HelpImgCard,
    SearchBox,
    DialogExperienceAccount,
    NoData,
    Footer
  },
  computed: {
    ...mapGetters(['fixedModuleIds'])
  },
  data() {
    return {
      keywordList: [],
      hideKeyWordList: true,
      bannerImg: '',
      bannerLink: '',
      module1List: [],
      module2List: [],
      module3List: [],
      module4List: [],
      category1: {},
      category2: {},
      category3: {},
      category4: {},
      // fixedModuleIds: [],
      isVisible: false
    }
  },
  created() {
    const _this = this
    _this.$store.commit('SET_TITLE', this.$t('help.helpCenter'))
    document.documentElement.addEventListener('click', function(e) {
      if (!_this.hideKeyWordList && e.target.className !== 'el-input__inner') {
        _this.hideKeyWordList = true
      }
    })
    this.handleGetConfig()
    // this.handleGetIndexCategory()
  },
  methods: {
    handleGetConfig() {
      getHomePageSetting().then(response => {
        const content = response.data.content
        const modules = content.modules
        this.bannerImg = content.bannerImg
        this.bannerLink = content.bannerLink
        if (modules && modules.length) {
          modules.map((item, index) => {
            this[`category${index + 1}`] = item
            if (index === 3) {
              this.handleGetArticleList({ limit: 6, categoryId: modules[index].categoryId }, index)
            } else {
              this.handleGetArticleList({ limit: 5, categoryId: modules[index].categoryId }, index)
            }
          })
        }
      })
    },
    handleGetIndexCategory() {
      getIndexCategory().then(response => {
        const content = response.data.content
        this.fixedModuleIds = content.rowIds
      })
    },
    handleGetArticleList(params, index) {
      getHelpArticleList({
        page: 0,
        limit: params.limit,
        exactMatchArr: [
          {
            name: 'categoryId',
            valueArr: [params.categoryId]
          }
        ]
      }).then(response => {
        this[`module${index + 1}List`] = response.data.content.itemArr
      })
    },
    handleGoToInnerPage(index) {
      if (index) {
        this.$router.push({
          path: `/help/content?categoryId=${this.fixedModuleIds[index - 1]}&categoryName=''&type=${
            CATEGORY_TYPE.ARTICLE
          }`
        })
      } else {
        this.$router.push({
          path: `/help/content?categoryId=${this.category4.categoryId}&categoryName=${this.category4.categoryName}&type=${CATEGORY_TYPE.ARTICLE}`
        })
      }
    },
    handleGotoDownLoad() {
      this.$router.push({
        path: `/help/content?categoryId=${this.downloadId}&categoryName=''&type=${CATEGORY_TYPE.FILE}&tab=0`
      })
    },
    handeClickBanner() {
      if (!this.bannerLink) return
      window.open(this.bannerLink, 'help')
    },
    handleSearch(keyword) {
      this.$router.push({
        path: `/help/search?keyword=${encodeURIComponent(keyword)}`
      })
    },

    handleGotoExperience() {
      this.isVisible = true
    },
    handleCloseExperience() {
      this.isVisible = false
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(hc-index) {
  @include e(banner) {
    width: 100%;
    height: 440px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  @include e(banner-img) {
    position: absolute;
    width: 100%;
    height: 440px;
    background-size: cover;
    background-position: center center;
    z-index: 1;
  }
  @include e(search-box) {
    display: flex;
    width: 860px;
  }
  @include e(content) {
    padding: 0 360px;
  }
  @include e(quick-box) {
    display: flex;
    margin-top: 61px;
  }
  @include e(quick-item) {
    height: 58px;
    border-right: 1px solid #c7c7c7;
    flex: 1;
    display: flex;
    cursor: pointer;
    &:last-child {
      border-right: 0px;
    }
    &:first-child {
      cursor: default;
    }
  }
  @include e(quick-item-tit) {
    justify-content: center;
    display: flex;
    align-items: center;
    line-height: 31px;
    color: $--color-grey-8;
    font-weight: bold;
    font-size: $--font-size-x-large;
  }
  @include e(quick-con) {
    padding-left: 40px;
  }
  @include e(quick-tit) {
    font-size: $--font-size-big;
    color: $--color-grey-8;
    font-weight: bold;
    line-height: 26px;
    margin-top: 5px;
  }
  @include e(quick-txt) {
    font-size: $--size-base;
    color: $--color-grey-8;
    line-height: 19px;
    margin-top: 4px;
  }
  @include e(article-box) {
    display: flex;
    justify-content: space-between;
    margin-top: 61px;
  }
  @include e(article-item) {
    width: 377px;
  }

  @include e(img-article-tit) {
    font-size: $--font-size-big;
    margin-top: 35px;
    margin-bottom: 20px;
    cursor: pointer;
  }
  @include e(img-article-item) {
  }
  @include e(img-article-box) {
    display: flex;
    flex-wrap: wrap;
  }
  @include e(quick-icon) {
    display: block;
    margin-left: 21px;
    @include m(product) {
      width: 43px;
      height: 44px;
      margin-top: 7px;
    }
    @include m(guide) {
      width: 42px;
      height: 43px;
      margin-top: 8px;
    }
    @include m(instructions) {
      width: 44px;
      height: 44px;
      margin-top: 7px;
    }
    @include m(experience) {
      width: 44px;
      height: 38px;
      margin-top: 8px;
    }
  }
  @include e(img-article-no-data) {
    padding-bottom: 30px;
  }
}
</style>
<style lang="scss">
.sky-hc-index__img-article-box {
  .sky-hc-img-card {
    &:nth-child(3n) {
      margin-right: 0px;
    }
  }
}
</style>
